<template>
  <div class="flex h-14 shrink-0 touch-none items-center justify-between border-b border-light-bd-muted bg-white px-4">
    <h2 class="text-sm font-bold text-light-fg-emphasis">Wabunka AI Chat</h2>
    <div class="flex items-center gap-2">
      <button class="rounded p-1 text-xs text-light-fg-muted transition-colors hover:text-light-fg-default" type="button" @click="$emit('reset')">Reset</button>
      <button aria-label="Close chat" class="flex size-8 items-center justify-center rounded text-light-fg-muted transition-colors hover:text-light-fg-default" type="button" @click="$emit('close')">
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits<{
  reset: [];
  close: [];
}>();
</script>
